import classes from "./App.module.css";
import ClockPage from "./pages/ClockPage";

function App() {
  return (
    <div className={classes.App}>
      <h1 className={classes.title}> 25分鐘工作時間番茄鐘</h1>
      <ClockPage />
    </div>
  );
}

export default App;
